module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flexContainer fd-r m-fd-c t-fd-c flex-1",
    attrs: {
      "id": "loginWrapper"
    }
  }, [(_vm.suffix && (_vm.suffix === 'pp-api.rem3rch.com' || _vm.suffix === 'api.rem3rch.com')) ? _c('div', {
    staticClass: "imgLogin size3of4"
  }, [_c('anim')], 1) : _vm._e(), _vm._v(" "), (_vm.suffix && _vm.suffix !== 'pp-api.rem3rch.com' && _vm.suffix !== 'api.rem3rch.com') ? _c('div', {
    staticClass: "imgLogin size3of4",
    staticStyle: {
      "font-size": "50px",
      "background-color": "deeppink"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.suffix) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login size1of4 flexContainer fd-c jc-c rel"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexContainer fd-c loginForm full rel"
  }, [_c('img', {
    attrs: {
      "id": "logoRem3rch",
      "src": require("../../assets/Logo-login.png"),
      "width": "150px",
      "alt": ""
    }
  }), _vm._v(" "), (_vm.currentStatus === _vm.status.FIRST_STEP) ? _c('div', [_c('div', {
    staticClass: "input-group rel"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.login),
      expression: "user.login",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "id": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.login)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.goToSecondStep()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.login = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "abs",
    attrs: {
      "src": require("../../../static/img/user.png"),
      "width": "21",
      "height": "18",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn log loginButton",
    on: {
      "click": function($event) {
        _vm.goToSecondStep()
      }
    }
  }, [_vm._v("Next")])]) : _vm._e(), _vm._v(" "), (_vm.currentStatus === _vm.status.SECOND_STEP) ? _c('div', [_c('p', {
    staticClass: "user-email",
    on: {
      "click": function($event) {
        _vm.currentStatus = _vm.status.FIRST_STEP
      }
    }
  }, [_c('span', {
    staticClass: "left-arrow"
  }, [_vm._v("←")]), _vm._v(_vm._s(_vm.user.login))]), _vm._v(" "), _c('div', {
    staticClass: "input-group rel"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.pwd),
      expression: "user.pwd",
      modifiers: {
        "trim": true
      }
    }],
    ref: "passwordField",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.pwd)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.check()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.pwd = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "abs",
    attrs: {
      "src": require("../../../static/img/pwd.png"),
      "width": "12",
      "height": "18",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn log loginButton",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.check()
      }
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('button', {
    staticClass: "btn log loginButton",
    staticStyle: {
      "white-space": "normal"
    },
    on: {
      "click": function($event) {
        _vm.triggerResetPassword()
      }
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), (_vm.cgu) ? _c('div', [_c('label', {
    staticClass: "condition"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cookiesChecked),
      expression: "cookiesChecked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "agree"
    },
    domProps: {
      "checked": Array.isArray(_vm.cookiesChecked) ? _vm._i(_vm.cookiesChecked, null) > -1 : (_vm.cookiesChecked)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cookiesChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.cookiesChecked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cookiesChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cookiesChecked = $$c
        }
      }
    }
  }), _vm._v(" I have read and agree to the Rem3rch\n                        "), _c('a', {
    staticClass: "supportLink",
    attrs: {
      "target": "_blank",
      "href": "../../../static/Rem3rch_mentions_légales_conditions_utilisation.pdf"
    }
  }, [_vm._v("\n                            terms and conditions\n                        ")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentStatus === _vm.status.RESET_PASSWORD) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n                    Passwords should be at least 8 characters long and contain at least one lower case letter, one number and one upper case\n                    letter.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group rel"
  }, [(_vm.passwordReset.newPassword.isVisible) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordReset.newPassword.value),
      expression: "passwordReset.newPassword.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new password"
    },
    domProps: {
      "value": (_vm.passwordReset.newPassword.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordReset.newPassword.value = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordReset.newPassword.value),
      expression: "passwordReset.newPassword.value"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Enter new password"
    },
    domProps: {
      "value": (_vm.passwordReset.newPassword.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordReset.newPassword.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "abs password-icon",
    attrs: {
      "src": _vm.passwordIcon(_vm.passwordReset.newPassword.isVisible),
      "width": "12",
      "height": "18",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.passwordReset.newPassword.isVisible = !_vm.passwordReset.newPassword.isVisible
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group rel"
  }, [(_vm.passwordReset.newPasswordRepeat.isVisible) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordReset.newPasswordRepeat.value),
      expression: "passwordReset.newPasswordRepeat.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new password"
    },
    domProps: {
      "value": (_vm.passwordReset.newPasswordRepeat.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordReset.newPasswordRepeat.value = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordReset.newPasswordRepeat.value),
      expression: "passwordReset.newPasswordRepeat.value"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Enter new password"
    },
    domProps: {
      "value": (_vm.passwordReset.newPasswordRepeat.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordReset.newPasswordRepeat.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "abs password-icon",
    attrs: {
      "src": _vm.passwordIcon(_vm.passwordReset.newPasswordRepeat.isVisible),
      "width": "12",
      "height": "18",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.passwordReset.newPasswordRepeat.isVisible = !_vm.passwordReset.newPasswordRepeat.isVisible
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn log loginButton",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.sendNewPassword()
      }
    }
  }, [_vm._v("Submit")])]) : _vm._e()])], 1), _vm._v(" "), _c('Cookie')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ea4242e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 3173
// module chunks = 0